import { render, staticRenderFns } from "./ExpandedSections.vue?vue&type=template&id=4977b454&scoped=true"
import script from "./ExpandedSections.vue?vue&type=script&lang=js"
export * from "./ExpandedSections.vue?vue&type=script&lang=js"
import style0 from "./ExpandedSections.vue?vue&type=style&index=0&id=4977b454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4977b454",
  null
  
)

export default component.exports